import React from 'react';
import {observer} from 'mobx-react';
import {action} from 'mobx';
import Select from 'react-select-plus';
import 'react-select-plus/dist/react-select-plus.css';
import {injectIntl} from 'react-intl';
import {
    FormGroup, FormControl, ControlLabel,
    Form, Row, Col, Checkbox, Button, ButtonToolbar, Alert
} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';

import AttachmentsForm from '../common_components/attachments/AttachmentsForm';
import ButtonWithConfirmation from "../common_components/ButtonWithConfirmation";
import {KEY_ACTIVITY_TYPES} from "./constants";
import AITextEditor from '../AITextEditor';

@observer
class KeyActivitiesForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            label: "",
            name: "",
            types: [],
            description: "",
            attach_url: undefined,

            isEdition: false,
        };

        this.canDeleteCard = props.blockStore.rootStore.authorizationStore.canDeleteCard(props.blockStore.editingCard);

        this.renderSaveOrUpdateButton = this.renderSaveOrUpdateButton.bind(this);
        this.handleLabelChange = this.handleLabelChange.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleTypesChange = this.handleTypesChange.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDelete = this.handleDelete.bind(this);

    }

    render() {
        return (
            <div>
                {this.renderForm()}
            </div>
        );
    }

    renderForm() {
        const {blockStore, intl} = this.props;

        let cancelBtn;

        if (this.props.hideCancelBtn == null) {
            cancelBtn = <Button bsStyle="default" onClick={this.handleCancel}>
                {intl.formatMessage({id: "cancel"})}
            </Button>;
        } else {
            cancelBtn = <div></div>;
        }


        const labelValue = this.state.label.trim() ?
            intl.formatMessage({
                id: this.state.label,
                defaultMessage: " "
            }) : "";

        return (
            <div>

                {this.state.isEdition && (

                    <FormGroup
                        controlId="LabelKAId"
                        validationState={this.validateLabel()}>
                        <Row>
                            <Col xs={12} sm={2}>
                                <ControlLabel> {intl.formatMessage({id: "station"})} </ControlLabel>
                            </Col>
                            <Col xs={12} sm={10}>
                                <FormControl
                                    type="text"
                                    value={labelValue}
                                    placeholder=""
                                    onChange={this.handleLabelChange}
                                    disabled={true}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                )}


                <FormGroup
                    controlId="NameKAId"
                    validationState={this.validateName()}>
                    <Row>
                        <Col xs={12} sm={2}>
                            <ControlLabel> {intl.formatMessage({id: "name"})}  </ControlLabel>
                        </Col>
                        <Col xs={12} sm={10}>
                            <FormControl
                                type="text"
                                value={this.state.name}
                                placeholder=""
                                onChange={this.handleNameChange}
                            />
                        </Col>
                    </Row>
                </FormGroup>


                <FormGroup controlId="DescriptionKAId" validationState={this.validateDescription()}>
                    <Row>
                        <Col xs={12} sm={2}>
                            <ControlLabel>{intl.formatMessage({id: "description"})}</ControlLabel>
                        </Col>
                        <Col xs={12} sm={10}>
                            <AITextEditor
                                value={this.state.description}
                                onChange={(value) => this.setState({description: value})}
                                context="El texto con el que estás trabajando es sobre la descripción de actividades clave en un modelo de negocio Canvas. Las actividades clave son las acciones más importantes que una empresa debe realizar para que su modelo de negocio funcione. Incluye producción, resolución de problemas, plataforma/red, marketing, operaciones, etc."
                                rows={4}
                                placeholder=""
                            />
                        </Col>
                    </Row>
                </FormGroup>

                {this.renderTypesSelect()}


                <AttachmentsForm attachable={blockStore.editingCard}/>

                <br/>

                <ButtonToolbar className="pull-right">
                    {this.renderSaveOrUpdateButton()}

                    {this.state.isEdition && this.canDeleteCard && (
                        <ButtonWithConfirmation dropdownClassname="bmc-card-delete-button"
                                                confirmationMessage={intl.formatMessage({id: "delete_confirmation_msg"})}
                                                option1Label={intl.formatMessage({id: "delete_confirmation_no"})}
                                                option2Label={intl.formatMessage({id: "delete_confirmation_yes"})}
                                                onOption2Select={this.handleDelete}
                                                dropup>
                            {intl.formatMessage({id: "delete"})}
                        </ButtonWithConfirmation>
                    )}

                    {cancelBtn}
                </ButtonToolbar>

                <div className="clearfix"/>

            </div>
        );
    }

    renderTypesSelect() {

        //const {intl} = this.props;
        return (

            <FormGroup
                controlId="TypeKRId"
                validationState={this.validateTypes()}
            >
                <Row>
                    <Col xs={12} sm={2}>
                        <ControlLabel> {this.props.intl.formatMessage({id: "types"})} </ControlLabel>
                    </Col>
                    <Col xs={12} sm={10}>
                        <Select
                            multi
                            onChange={this.handleTypesChange}
                            value={this.state.types}
                            placeholder=""
                            options={this.renderTypeSelectOptions()}
                        />
                    </Col>
                </Row>
            </FormGroup>
        );
    }

    renderTypeSelectOptions() {

        return Object.entries(KEY_ACTIVITY_TYPES).map(i => ({
            value: i[1],
            label: this.props.intl.formatMessage({id: i[1]})
        }));


        // const options = [
        //     {
        //         value: KEY_ACTIVITY_TYPES.PRODUCTION,
        //         label: this.props.intl.formatMessage({id: KEY_ACTIVITY_TYPES.PRODUCTION})
        //     },
        //     {
        //         value: KEY_ACTIVITY_TYPES.PROBLEM_SOLVING,
        //         label: this.props.intl.formatMessage({id: KEY_ACTIVITY_TYPES.PROBLEM_SOLVING})
        //     },
        //     {
        //         value: KEY_ACTIVITY_TYPES.PLATFORM_NETWORK,
        //         label: this.props.intl.formatMessage({id: KEY_ACTIVITY_TYPES.PLATFORM_NETWORK})
        //     },
        //     {
        //         value: KEY_ACTIVITY_TYPES.REVENUE_STREAMS,
        //         label: this.props.intl.formatMessage({id: KEY_ACTIVITY_TYPES.REVENUE_STREAMS})
        //     }];
        // return options;
    }

    renderSaveOrUpdateButton() {

        if (this.state.isEdition) {
            return (
                <Button bsStyle="primary" onClick={this.handleUpdate}>
                    {this.props.intl.formatMessage({id: "save"})}
                </Button>
            )
        } else {
            const buttonMessage = this.props.blockStore.rootStore.stepByStepMode ? "save" : "add";

            return (
                <Button bsStyle="primary" onClick={this.handleSubmit}
                        disabled={!this.state.name && !this.state.description}>
                    {this.props.intl.formatMessage({id: buttonMessage})}
                </Button>
            )
        }


    }

    handleLabelChange(e) {
        //this.setState({label: e.target.value});
    }

    handleNameChange(e) {
        this.setState({name: e.target.value});
    }

    handleTypesChange(options) {
        //const values = getValuesFromHTMLSelectedOptions(options);
        this.setState({types: options});
    }

    handleDescriptionChange(e) {
        this.setState({description: e.target.value});
    }


    validateLabel() {

    }

    validateName() {

    }

    validateTypes() {

    }

    validateDescription() {

    }

    @action
    handleSubmit() {
        const card = this.generateCardFromState();
        this.props.blockStore.addCard(card);
        this.props.blockStore.showBlockModal(false);

        this.resetForm();
    }


    @action
    handleCancel() {
        const {blockStore} = this.props;
        blockStore.hideBlockModal(true);

        this.resetForm();
    }

    @action
    handleUpdate() {
        this.generateCardFromState();

        const {blockStore} = this.props;

        if (blockStore.editingCard.persisted) {
            blockStore.editingCard.update();
            blockStore.showBlockModal(false);
        }
    }


    @action
    handleDelete() {
        this.props.blockStore.editingCard.destroy();
        this.props.blockStore.hideBlockModal(true);

    }


    generateCardFromState() {
        const {editingCard} = this.props.blockStore;

        editingCard.label = this.state.label;
        editingCard.name = this.state.name;
        editingCard.types = this.state.types.map(t => t.value);
        editingCard.description = this.state.description;

        return editingCard;
    }

    resetForm() {
        this.setState({
            label: "",
            name: "",
            types: [],
            description: "",
            attach_url: undefined,

            isEdition: false,

        });
    }


    componentDidMount() {
        this.initFields(this.props.blockStore.editingCard);
    }

    initFields(card) {
        //const card = this.props.blockStore.editingCard;
        this.setState({
            label: card.label,
            name: card.name,
            types: card.types.map(t => {
                return {value: t, label: this.props.intl.formatMessage({id: t})}
            }),
            description: card.description,

            isEdition: card.persisted,
        });
    }
}

export default injectIntl(KeyActivitiesForm);